<div id="wrapper">

    <!-- Navigation -->
    <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation">
        <!-- Brand and toggle get grouped for better mobile display -->

        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-ex1-collapse">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" routerlink="/Home" style="color:#FFE600;">&nbsp;&nbsp;
                <img src="./assets/static/EYwhite.png"
                    style="display:inline-block !important;vertical-align:bottom !important;margin-left:2vw;"
                    height="35" width="35"><span style="color:#F0F0F0 !important;font-size:20px;"></span>
            </a>

        </div>
        <!-- Top Menu Items -->
        <ul class="nav navbar-right top-nav">
            <li *ngIf="RoleID==1" style="cursor: pointer;">
                <a (click)="processTerminate()" title="Kill Process">
                    <span class="fa-stack fa-lg">
                        <span class="fa fa-cog fa-stack-1x">
                            <span class="fa fa-ban fa-stack-2x text-danger">

                            </span>
                        </span>
                    </span>
                </a>
            </li>
            <li class="dropdown show">
                <a class="dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" role="button"
                    aria-haspopup="true" aria-expanded="false" style="color:#f0f0f0!important;">
                    {{show_name}} &nbsp;
                    <img src="./assets/static/icon-user-login.png" width="30" height="30" />&nbsp;&nbsp;<img
                        src="./assets/static/down-arrow.png" width="10" height="5" />
                </a>
                <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenuLink">
                    <li>
                        <span class="dropdown-item fa fa-power-off" style="padding-left: 10px;">
                            <a (click)="logout()"
                                style="font-size: 14px;font-family: EY;text-decoration: none;color: gray;padding-left: 10px;cursor: pointer;">Logout</a>
                        </span>
                    </li>
                </ul>
            </li>
        </ul>

        <!-- Sidebar Menu Items - These collapse to the responsive navigation menu on small screens -->
        <div class="collapse navbar-collapse navbar-ex1-collapse">
            <ul class="nav navbar-nav side-nav" style="font-size:16px !important;">
                <li *ngIf="RoleID==1 || RoleID==2" id="tab1" style="text-align:center;border-bottom:1px #494949 solid;"
                    tabindex="1" (click)="onSelect('home');getUsersector() ">
                    <a routerLink="/Home" routerLinkActive="active" class="selectionBox" [style]="getStyle('home')">
                        <div class="home" [style]="getStyleImg('home')"></div><br />Home
                    </a>

                </li>
                <li *ngIf="RoleID==1 || RoleID==2" id="tab2" style="text-align:center;border-bottom:1px #494949 solid;"
                    tabindex="2" (click)="onSelect('train')">
                    <a routerLink="/Train" class="selectionBox" [style]="getStyle('train')">
                        <div class="train" [style]="getStyleImg('train')"></div><br />Train the System
                    </a>

                </li>
                <li *ngIf="UserCheck.UserExists == true" id="tab3"
                    style="text-align:center;border-bottom:1px #494949 solid;" tabindex="3"
                    (click)="onSelect('predict')">
                    <a routerLink="/Predict" class="selectionBox" [style]="getStyle('predict')">
                        <div class="predict" [style]="getStyleImg('predict')"></div><br />Predict
                    </a>

                </li>
                <li *ngIf="RoleID==1" id="tab4" style="text-align:center;border-bottom:1px #494949 solid;" tabindex="4"
                    (click)="onSelect('manageUser')">
                    <a routerLink="/ManageUser" class="selectionBox" [style]="getStyle('manageUser')">
                        <div class="manage" [style]="getStyleImg('manageUser')"></div><br />Manage Users & Components
                    </a>
                </li>

                <li *ngIf="RoleID==1 || RoleID==2" id="tab5" style="text-align:center;border-bottom:1px #494949 solid;"
                    tabindex="5" (click)="onSelect('config')">
                    <a routerLink="/Config" class="selectionBox" [style]="getStyle('config')">
                        <div class="config" [style]="getStyleImg('config')"></div><br />Rules & Exceptions
                    </a>
                </li>

                <li *ngIf="UserCheck.UserExists == false" id="tab6"
                    style="text-align:center;border-bottom:1px #494949 solid;" tabindex="6">
                    <a routerLink="/No_user" class="selectionBox"></a>

                </li>
            </ul>

        </div>
    </nav>
    <!-- /.navbar-collapse -->


    <div id="page-wrapper" style="margin:0 !important; ">
        <div class="container-fluid" style="margin-top: 20px !important;">
            <!-- Page Heading -->
            <div class="row" style="margin:0 0 3px 0!important;">

                <div class="col-lg-8">
                    <h3 style="text-decoration: none !important;color:#333 !important;
                    font-size:24px !important;">{{Heading}}
                    </h3>
                </div>

                <form action="">
                    <div class="col-lg-2">
                        <div class="form-group ">
                            <div>
                                <select class="form-control" id="Sector" name="Sector" (change)="getmodels();"
                                    [(ngModel)]="SectorName" required>
                                    <option value=null>Choose Sector</option>
                                    <option *ngFor="let sec of sectors" value={{sec}}>
                                        {{sec}}
                                    </option>
                                </select>
                            </div>
                            <div class="editor-label" style="color:#666!important;">
                                Sector : <br><span class="small">{{SectorName}}</span>

                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2">
                        <div class="form-group ">
                            <div>

                                <select class="form-control" id="Model" name="Model" (change)="PassSectorModel()"
                                    [(ngModel)]="ModelName" required>
                                    <option value=null>Choose Model</option>
                                    <option *ngFor="let model of models" value={{model.ModelName}}>
                                        {{model.ModelName}}
                                </select>
                            </div>
                            <div class="editor-label" style="color:#666!important;">
                                Model : <br><span class="small">{{ModelName}}</span>

                            </div>
                        </div>
                    </div>
                </form>


                <router-outlet></router-outlet>
                <!-- <app-nouser *ngIf="UserCheck.UserExists == false"></app-nouser> -->

            </div>
        </div>
        <!-- /.container-fluid -->

    </div>
    <!-- /#page-wrapper -->

</div>
<!-- /#wrapper -->

<div id="modal-container" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
        </div>
    </div>
</div>

<app-loader *ngIf="showLoader" message="Application is loading..."></app-loader>